import React, { Component } from 'react';
import { connect } from 'react-redux';
import Media from 'react-media';

import classes from './TupleClubbed.scss';

import AnimakitExpander from "animakit-expander";
import moment from 'moment';

import Tuple from '../Tuple/Tuple';

import AirlineLogo from '../Airline/AirlineLogo/AirlineLogo';
import AirlineCode from '../Airline/AirlineCode/AirlineCode';
import AirlinePrice from '../Airline/AirlinePrice/AirlinePrice';
import Tooltip from '../../UI/Tooltip/Tootip';

// Airline
import AirlineWrapper from '../Wrappers/AirlineWrapper/AirlineWrapper';
import AirlineName from '../Airline/AirlineName/AirlineName';

// Stopover
import StopoverWrapper from '../Wrappers/StopoverWrapper/StopoverWrapper';
import AirlineStopover from '../Airline/AirlineStopover/AirlineStopover';

// Duration
import DurationWrapper from '../Wrappers/DurationWrapper/DurationWrapper';
import AirlineDuration from '../Airline/AirlineDuration/AirlineDuration';

// Timing
import TimingWrapper from '../Wrappers/TimingWrapper/TimingWrapper';
import AirlineTiming from '../Airline/AirlineTiming/AirlineTiming';

import cheapestFlightImage from '../../../assets/images/cheapest.svg';

import { arrivalDuration } from '../../../utility';

import ContainerPrimary from '../UI/Mobile/Tuple/ContainerPrimary/ContainerPrimary';
import ContainerSecondary from '../UI/Mobile/Tuple/ContainerSecondary/ContainerSecondary';
import ContainerSecondaryLeft from '../UI/Mobile/Tuple/ContainerSecondaryLeft/ContainerSecondaryLeft';
import ContainerSecondaryRight from '../UI/Mobile/Tuple/ContainerSecondaryRight/ContainerSecondaryRight';
import MobileTupleDivider from '../UI/Mobile/Tuple/TupleDivider/TupleDivider';
import MobileTimings from '../UI/Mobile/Tuple/Timings/Timings';
import MobileDuration from '../UI/Mobile/Tuple/Duration/Duration';
import AgencySummary from '../AgencySummary/AgencySummary';
import BoxCheapest from '../UI/Desktop/Tuple/BoxCheapest/BoxCheapest';
import BoxSeat from '../UI/Desktop/Tuple/BoxSeat/BoxSeat';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class TupleClubbed extends Component {

    state = {
        trigger: false,
        isAgencyFareSummaryVisible: false
    }

    triggerHandler = (e) => {
        e.stopPropagation();
        this.setState(prevState => {
            return { trigger: !prevState.trigger }
        })
    }

    handleClick = (e) => {
        if (this.node.contains(e.target)) return;
        this.setState({ isFareSummaryVisible: false });
    }
    
    toggleAgencyFareSummaryVisible = () => {
        this.setState(prevState => {
          return { isAgencyFareSummaryVisible: !prevState.isAgencyFareSummaryVisible }
        })
    }

    render() {
        const OD = this.props.flight[0].OD[0];
        const FS = OD.FS;
        const airlineCode = this.props.flightSchedule[0].FS[0].ac;
        const TF = this.props.fareDetails.revisedFareDetails.tf;
        let arrivalDate = null;
        // Check of arrival and departure dates
        if(!moment(FS[0].ddt).isSame(FS[FS.length - 1].adt)) {
            arrivalDate = moment(FS[FS.length - 1].adt).format("DD MMM");
        }
        const border = '1px solid var(--color-border)';

        return (
            <div
                className={classes.TupleWrapper}
                onClick={this.triggerHandler}>
             {
                 !this.state.trigger ? (
                    <Media query="(max-width: 599px)">
                        {matches =>
                            matches ? (
                                <div
                    className={classes.TupleContainer}
                    style={{ borderBottom: this.state.trigger ? `${border}` : 'none' }}>
                    <ContainerPrimary>
                        <AirlineLogo airlineCode={airlineCode} />
                    </ContainerPrimary>
                  <ContainerSecondary>
                      <ContainerSecondaryLeft>
                        <div className={`u-flex justify-content-between u-width100Percent mb-2 u-lineHeight1`}>
                            <MobileTimings>
                                <span>{FS[0].dd}</span>
                                <MobileTupleDivider/>
                                <span>{FS.length === 1 ? FS[0].ad : FS[FS.length - 1].ad}</span>
                            </MobileTimings>
                            <AirlinePrice 
                                onClick={this.proceedToBook} 
                                index={this.props.index} 
                                tf={TF} />
                            {this.props.showAgentProfit ? <p className={`u-absolute u-top35Percent u-right5Percent`}><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.commision).toLocaleString()}</span><span className={`mr-1 ml-1 mt-1`}>|</span><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.nf).toLocaleString()}</span></p> : null}
                        </div>
                        <div>
                            <div style={{width: '56.88%'}} className={`u-flex justify-content-between`}>
                                <MobileDuration>
                                    <span>{OD.tdu.substring(0, 2) + "h " + OD.tdu.substring(3, 5) + "m"}</span>
                                </MobileDuration>
                                <StopoverWrapper>
                                <AirlineStopover cityNames={this.props.cityNames} OD={OD} FS={FS} />
                                </StopoverWrapper>
                            </div>
                        </div>
                      </ContainerSecondaryLeft>
                      <ContainerSecondaryRight>
                        <p className={classes.AirlineDetail}>
                            <AirlineName FS={FS} airlineNames={this.props.airlineNames} />
                            <span>&nbsp;&nbsp;</span>
                            <AirlineCode FS={FS} />
                        </p>
                        <span style={{lineHeight: '1'}} className={classes.More}>+ {this.props.flight.length} more options</span>
                      </ContainerSecondaryRight>
                  </ContainerSecondary>
                    </div>
                            ) : (
                    <div className={classes.TupleContainer}
                        style={{ borderBottom: this.state.trigger ? `${border}` : 'none' }}>
                        <div className={classes.TupleContainerPrimary}>
                            <AirlineWrapper>
                                <AirlineLogo airlineCode={airlineCode} />
                                <p className={classes.AirlineDetail}>
                                    <AirlineName FS={FS} airlineNames={this.props.airlineNames} />
                                    <AirlineCode FS={FS} />
                                </p>
                            </AirlineWrapper>
                            <TimingWrapper>
                                <AirlineTiming>{FS[0].dd}</AirlineTiming>
                                <span className={classes.Line}></span>
                                <AirlineTiming>{arrivalDuration(this.props.flightSchedule)} {arrivalDate !== null ? <span className={`${classes.ArrivalDate} u-textColorRed`}>{arrivalDate}</span> : null}</AirlineTiming>
                            </TimingWrapper>
                            <DurationWrapper>
                                <AirlineDuration OD={OD} />
                            </DurationWrapper>
                            <StopoverWrapper>
                                <AirlineStopover cityNames={this.props.cityNames} OD={OD} FS={FS} />
                            </StopoverWrapper>
                        </div>
                        <div className={classes.TupleContainerSecondary}>
                            <div className={classes.Box1}>
                                {this.props.index === 0 ? 
                                <React.Fragment>
                                    {FS[0].sl === '' || !FS[0].sl || parseInt(FS[0].sl, 10) >= 9 ? null : <BoxSeat>{FS[0].sl}</BoxSeat>}
                                    <BoxCheapest>
                                        <Tooltip type="stopCity" aria-label="Cheapest"><img src={cheapestFlightImage} alt="Cheapest Flight" /></Tooltip>
                                    </BoxCheapest>
                                </React.Fragment> : FS[0].sl === '' || !FS[0].sl || parseInt(FS[0].sl, 10) >= 9 ? null : <BoxSeat>{FS[0].sl}</BoxSeat>}
                                <div className={classes.Box1Extended}>
                                    <div className={classes.Price} onMouseEnter={() => this.toggleAgencyFareSummaryVisible()} onMouseLeave={() => this.toggleAgencyFareSummaryVisible()}>
                                    {this.state.isAgencyFareSummaryVisible ? <AgencySummary fareDetails={this.props.fareDetails}/> : null}
                                        <AirlinePrice
                                            price={this.props.index} 
                                            tf={TF} />
                                    {this.props.showAgentProfit ? <p><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.commision).toLocaleString()}</span><span className={`mr-1 ml-1 mt-1`}>|</span><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.nf, 10).toLocaleString()}</span></p> : null}
                                    </div>
                                </div>
                            </div>
                            <div className={classes.Box2}>
                                <div className={`${classes.DividerLeft} u-phoneHide`}></div>
                                <div className={`u-textAlignRight`}> 
                                    <span className={`u-textColorPrimary u-fontSize13 u-fontWeightMedium`}>+{this.props.flight.length - 1} more</span>
                                    <span className={`u-phoneHide u-block u-textColorPrimary u-fontSize13`}>options</span>
                                </div>
                                <div className={`u-phoneHide`}>
                                    <FontAwesomeIcon icon="angle-down" color="#666" size="lg" />
                                </div>
                            </div>
                        </div>
                    </div>
                            )}
                    </Media>
                 ) : null
             }      
            <AnimakitExpander
                expanded={this.state.trigger}
                duration={350}
                align="top"
            >
                { 
                    this.props.flight.map((tuple, index) => {
                        return (
                            <Tuple
                                type={this.props.type}
                                clubbed={true} 
                                flightSchedule={tuple.OD} 
                                key={index.toString()}
                                xmlKey={tuple.xmlKey} 
                                fareDetails={tuple.FD.O} 
                                index={this.props.index}
                                supplierCode={tuple.supplierCode}
                                flightId={tuple.ID}
                                scrollTop={this.props.scrollTop}
                                />        
                            );
                        }
                    )    
                }
            </AnimakitExpander>
        </div>
        )
    };
}

const mapStateToProps = state => {
    return {
        cityNames: state.flights.cityNames,
        showAgentProfit: state.ui.showAgentProfit
    }
}

export default connect(mapStateToProps)(TupleClubbed);


// WEBPACK FOOTER //
// ./src/components/Flight/TupleClubbed/TupleClubbed.js